module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"BDP Data Market","short_name":"BDP Data Market","start_url":"/","background_color":"#ffffff","theme_color":"#141414","icon":"node_modules/@oceanprotocol/art/logo/favicon-white.png","display":"standalone","cache_busting_mode":"none","legacy":true,"theme_color_in_head":true,"crossOrigin":"anonymous","include_favicon":true,"cacheDigest":null},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
